import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ToastrManager } from 'ng6-toastr-notifications';
import { forkJoin } from 'rxjs';
import { EtType } from 'src/app/et-type';
import { ExpenseType } from 'src/app/models/expense-type';
import { ExpenseService } from 'src/app/services/expense.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-expense-type',
  templateUrl: './expense-type.component.html',
  styleUrls: ['./expense-type.component.css']
})
export class ExpenseTypeComponent implements OnInit {

  public expTypes: ExpenseType[] = [];
  public expTypesAll: ExpenseType[] = [];
  loading: boolean = false;
  public expType: ExpenseType = new ExpenseType;
  public find: string = '';
  public idExpType: number = 0;
  public etTypes: EtType[] = [];
  public etTypesAll: EtType[] = [];
  public etTypeId = 0;
  //Pagination
  public page:number = 1;
  public pagination:number = 20;

  constructor(private expServices: ExpenseService, private toastr: ToastrManager, private utl: UtilitiesService, private modalService:NgbModal) { }

  ngOnInit() {
    this.getAllExpenseTypes();
  }

  getAllExpenseTypes(){
    this.loading = true;
    forkJoin([this.expServices.getExpenseTypes(), this.expServices.getEtTypes()]).subscribe(([_expTypes, _etTypes]) =>{
      this.expTypes = _expTypes;
      this.etTypes = _etTypes;
      this.etTypesAll = this.etTypes;
      this.filter();
      this.loading = false;
    }, error => {
      this.loading = true;
      this.toastr.warningToastr('Ocurrio un error al obtener los tipos de gastos.', '', {enableHTML: true});
    })
  }

  newExpenseType(modal){
    this.loading = true;
    this.defaultData();
    this.etTypeId = this.etTypes[0].id;
    this.setType(this.etTypeId);
    this.modalService.open(modal, { size: 'lg' });
    this.loading = false;
  }

  updExpenseType(modal, id: number){
    this.loading = true;
    this.idExpType = id;
    this.expType = this.expTypes.find(et => et.id == this.idExpType);
    this.etTypeId = this.expType.et_type_id;
    this.modalService.open(modal, { size: 'lg' });
    this.loading = false;
  }

  delExpenseType(modal, id:number){
    this.loading = true;
    this.idExpType = id;
    this.expType = this.expTypes.find(et => et.id == this.idExpType);
    this.modalService.open(modal, { size: 'lg' });
    this.loading = false;
  }

  addExpenseType(){
    this.loading = true;
    this.expServices.postExpenseType(this.expType).then(response => {
      this.defaultData();
      this.defaultDataCatalogs();
      this.expTypes = response;
      this.modalService.dismissAll();
      this.getAllExpenseTypes();
      this.loading = false;
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  updateExpenseType(){
    this.loading = true;
    this.expServices.putExpenseType(this.expType).then(response => {
      this.defaultData();
      this.defaultDataCatalogs();
      this.expTypes = response;
      this.modalService.dismissAll();
      this.getAllExpenseTypes();
      this.loading = false;
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  deleteExpenseType(){
    this.loading = true;
    this.expServices.deleteExpenseTypes(this.expType).then(response => {
      this.defaultData();
      this.defaultDataCatalogs();
      this.expTypes = response;
      this.modalService.dismissAll();
      this.getAllExpenseTypes();
      this.loading = false;
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  defaultData(){
    this.idExpType = 0;
    this.etTypeId = 0;
    this.find = '';
    this.expType = new ExpenseType;
  }

  defaultDataCatalogs(){
    this.expTypes = [];
    this.expTypesAll = [];
    this.etTypes = [];
    this.etTypesAll = [];
  }

  filter(){ this.utl.search(this.expTypes, ['id', 'name', 'et_type_name', 'apply_unit'], this.find, 'id', expTypes => this.expTypesAll = expTypes); }

  getType(){ 
    this.expType.et_type_id = this.etTypeId;
    this.expType.et_type_name = this.etTypesAll.find(et => et.id == this.etTypeId).name;
    this.setType(this.etTypeId);
  }

  setType(id:any){
    switch(id)
    {
      case '1': this.expType.type = 'Variable'; break;
      case '2': this.expType.type = 'Fijo'; break;
      case '3': this.expType.type = 'Viaje'; break;
      case '4': this.expType.type = 'Mantenimiento'; break;
      case '5': this.expType.type = 'Seguros'; break;
      case '6': this.expType.type = 'Rentas'; break;
      // case 1: this.expType.type = 'Variables'; break;
      // case 2: this.expType.type = 'Fijos'; break;
      // case 3: this.expType.type = 'Viaje'; break;
      // case 4: this.expType.type = 'Mantenimiento'; break;
      // case 5:
      // case 6: this.expType.type = 'Fijos'; break;
    }
  }
}
